import script from "./BaseLandingList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLandingList.vue?vue&type=script&setup=true&lang=ts"

import "./BaseLandingList.vue?vue&type=style&index=0&id=2d453fbd&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d453fbd"]])

export default __exports__
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInfiniteScroll,QSpinnerDots,QSpinner});
